type HandleBenefitIdsParams = {
    commonBenefits: any;
    serviceRequest: any;
    tireChangeServiceDetails: any;
}

export const handleBenefitIds = ({ commonBenefits, serviceRequest, tireChangeServiceDetails }: HandleBenefitIdsParams): any | undefined => {
  const isTireService = serviceRequest?.serviceTypeOptions?.tire;
  const isJumpStartService = serviceRequest?.serviceTypeOptions?.battery;
  const walmartMixedCoverage = tireChangeServiceDetails?.additionalCoverage;

/**
 * Walmart partner: when a user has both standard and enhanced benefits,
 * tire change and jumpstart services use IDs from serviceRequest.
 * All other services use commonBenefits IDs.
 */
  const memberId = walmartMixedCoverage?.memberId 
    ? (isTireService || isJumpStartService)
      ? serviceRequest?.memberId
      : commonBenefits?.memberId
    : undefined;

  const partnerMemberId = walmartMixedCoverage?.partnerMemberId 
    ? (isTireService || isJumpStartService)
      ? serviceRequest?.partnerMemberId
      : commonBenefits?.partnerMemberId
    : undefined;

  return { memberId, partnerMemberId };
};